<form [formGroup]="formGroup"
      (ngSubmit)="onSubmit()"
      class="change-password-root">
  <div class="image">
    <ng-content select="[image]"></ng-content>
  </div>
  <ng-content select="[divider]"></ng-content>
  <div class="text">
    <ng-content select="[text]"></ng-content>
  </div>
  <div class="input">
    <ng-content select="[input]"></ng-content>
  </div>
  <div class="form-feedback">
    <ng-content select="[form-feedback]"></ng-content>
  </div>
  <div class="error-message">
    <ng-content select="[isError]"></ng-content>
  </div>
  <div class="recaptcha">
    <ng-content select="[recaptcha]"></ng-content>
  </div>
  <div class="text">
    <ng-content select="[disclaimer-text]"></ng-content>
  </div>
  <div class="buttons">
    <ng-content select="[button]"></ng-content>
  </div>
</form>
